import React, { useState } from "react";
import RegionProfile from "../../../components/Region/Profile/Profile";
import Header from "../../../components/Header";
import ProfileBannerContainer from "../../../components/Profile/Banner/Container";
import { Query } from "react-apollo";
import { Type, TextBold, TextSize } from "../../../components/Type/Type";
import OrganizationSelect from "../../../components/Organization/Select/Container";
import Text from "../../../components/Type/Text"

import {
  Rowz,
  Card,
  Wrapper,
  Spacer,
  Spacers,
  Tgrid,
  tbGrids
} from "../../../components/Layout/Layout";
import { LIST_REGIONS, GET_ORGANIZATION } from "../../../graphql";

const RegionList = ({ match }) => {
  const [organizationID, setOrganizationID] = useState("");

  return (
    <React.Fragment>
      <Header/>
      <Rowz>
        <Wrapper>
          <Tgrid gr={tbGrids.grid20}>
            <Card>
              <Spacer>
                <ProfileBannerContainer />
              </Spacer>
            </Card>
          </Tgrid>
          <Tgrid gr={tbGrids.grid80}>
            <Spacer spacer={Spacers.sLargeL}>
              <Card>
                <Spacer>
                  <Type size={TextSize.lg} boldness={TextBold.bold}>
                    Regions
                  </Type>
                </Spacer>
                <Spacer>
                    <Rowz>
                      <Text>Organization:</Text>
                      <OrganizationSelect
                  onChange={orgID => setOrganizationID(orgID)}
                />
                    </Rowz>
                  </Spacer>
                

                {organizationID ? (
                  <Query
                    query={GET_ORGANIZATION}
                    variables={{ id: organizationID }}
                  >
                    {({ loading, error, data }) => {
                      if (loading) return "loading...";
                      if (error) return "error :(";

                      if (data.getOrganization) {
                          
                        return data.getOrganization.regions.map(
                          (region, idx) => (
                            <RegionProfile key={idx} region={region} />
                          )
                        );
                      }
                    }}
                  </Query>
                ) : (
                  <Query query={LIST_REGIONS}>
                    {({ loading, error, data }) => {
                      if (loading) return "loading...";
                      if (error) return "error :(";

                      if (data.listRegions) {
                        
                        return data.listRegions.map((region, idx) => (
                          <RegionProfile key={idx} region={region} />
                        ));
                      }
                    }}
                  </Query>
                )}
              </Card>
            </Spacer>
          </Tgrid>
        </Wrapper>
      </Rowz>
    </React.Fragment>
  );
};

export default RegionList;
